import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';

@Component({
  selector: 'app-generic-confirmation-dialog',
  templateUrl: './generic-confirmation-dialog.component.html',
  styleUrls: ['./generic-confirmation-dialog.component.scss']
})
export class GenericConfirmationDialogComponent implements OnInit {
  message: string;
  titleText: string;

  constructor(@Inject(MAT_DIALOG_DATA) data: any) {
    this.message = data.message;
    this.titleText = data.titleText;
  }

  ngOnInit(): void {
  }
}
